export const DIFFICULTY_LEVELS = Object.freeze([
  {
    value: 'Beginner',
    label: '1 ★ — Beginner',
    shortLabel: 'Beginner',
    stars: 1,
    description: 'For first projects using basic stitches, simple increases and decreases, and standard finishing.',
  },
  {
    value: 'Experienced Beginner',
    label: '2 ★★ — Experienced Beginner',
    shortLabel: 'Experienced Beginner',
    stars: 2,
    description: 'For knitters comfortable reading a simple pattern and ready for short rows, simple charts or basic finishing.',
  },
  {
    value: 'Intermediate',
    label: '3 ★★★ — Intermediate',
    shortLabel: 'Intermediate',
    stars: 3,
    description: 'Uses several established techniques such as picking up stitches, shaping, cables or more detailed construction.',
  },
  {
    value: 'Experienced Intermediate',
    label: '4 ★★★★ — Experienced Intermediate',
    shortLabel: 'Experienced Intermediate',
    stars: 4,
    description: 'Requires keeping track of multiple instructions at once, advanced charts or demanding finishing techniques.',
  },
  {
    value: 'Advanced',
    label: '5 ★★★★★ — Advanced',
    shortLabel: 'Advanced',
    stars: 5,
    description: 'For seasoned knitters working complex construction, advanced shaping and techniques within established patterns.',
  },
]);

export const YARN_WEIGHTS = Object.freeze([
  'Lace',
  'Fingering',
  'Sport',
  'DK',
  'Worsted',
  'Aran',
  'Bulky',
  'Super Bulky',
]);

export function normalizeDifficulty(value) {
  if (value === 'Expert') return 'Advanced';
  return DIFFICULTY_LEVELS.some((level) => level.value === value)
    ? value
    : DIFFICULTY_LEVELS[0].value;
}

export function getDifficultyLevel(value) {
  const normalized = normalizeDifficulty(value);
  return DIFFICULTY_LEVELS.find((level) => level.value === normalized);
}
